import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;
  border: 1px solid ${cssVar('fgColor')};

  [data-type='hidden'] & {
    border: none;
  }

  ${({ isSearch }) => isSearch &&
    css `
      ${() => Input} {
        height: 50px;
        padding-right: 60px;

        @media ${from(Device.Tablet)} {
          height: 73px;
          padding-right: 80px;
        }
      }
    `}
`;
const Input = styled.input `
  display: block;
  appearance: none;
  border-radius: 0;
  color: ${cssVar('fgColor')};
  ${fonts.sourceSansPro.regular};
  font-size: 16px;
  line-height: 20px;
  height: 48px;
  padding: 0 12px;
  width: 100%;
  border: none;

  @media ${from(Device.Desktop)} {
    font-size: 22px;
    line-height: 32px;
    padding: 0 24px;
  }

  ${({ hasError }) => hasError &&
    css `
      border-color: ${brand.validation.error};
    `}

  &:disabled {
    cursor: not-allowed;
    background-color: ${brand.white};
  }
`;
export const Icon = styled.span `
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  height: 20px;
  width: 20px;

  @media ${from(Device.Tablet)} {
    height: 24px;
    width: 24px;
  }
`;
export const SearchBtn = styled.button `
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: ${brand.hta.green};
  border: none;
  padding: 5px 10px;

  @media ${from(Device.Tablet)} {
    padding: 15px;
  }

  &:hover {
    background-color: ${brand.hta.greenAlt};
  }
`;
export const Search = styled.span `  
  display: block;
  color: ${brand.white};
  width: 31px;

  @media ${from(Device.Tablet)} {
    width: 41px;
  }
`;
const Error = styled.span `
  display: block;
  color: ${brand.validation.error};
  ${fonts.sourceSansPro.regular};
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 16px;
  margin: 8px 0 0 0;
`;
export default {
    Container,
    Error,
    Icon,
    Input,
    Search,
    SearchBtn,
};
